import { Mascot } from '@runner/ui';
import { Link } from '../app/router';
import { useWorld } from '../data/WorldProvider';
import { accountOverview } from '../data/account';
import { useEquipPref } from './runner';
import '../styles/account.css';

/** A quiet entry to ownership; the full portrait and balances live on the account page. */
export function RunnerDock() {
  const { view } = useWorld();
  const { owned } = accountOverview(view);
  const [pref] = useEquipPref();
  const runner = owned.find((r) => r.tokenId === pref.tokenId) ?? owned[0];
  return <Link to="/account" className="runner-dock" data-testid="runner-dock"><Mascot size={30} /><span>{runner ? `Runner #${runner.tokenId}` : 'Your Runner'}<small>{runner ? 'View your NFT & rewards' : 'Collection & deposit rewards'}</small></span><span aria-hidden="true">↗</span></Link>;
}
